import * as React from "react"
import bem from "../../../../../bem"

const b = bem.with("NewUI__tutorialList")

interface Props {
    tutorials: string[][]
    header: string[]
    searchManual: string
}
const TutorialList = ({ tutorials, searchManual }: Props): JSX.Element => (
    <div className={`bg-white ${b()}`}>
        <header className="section-header" tabIndex={0}>
            <h3>{searchManual}</h3>
        </header>
        {tutorials.map(([description, example], i) => (
            <div key={i} className="theme-thumb theme-thumb--wide">
                <div>
                    <div className="label is-dimmed">{description}</div>
                    <div>{example}</div>
                </div>
            </div>
        ))}
    </div>
)

export default TutorialList
